import React from 'react';
import SpinnerLoader from './../spinnerLoader/spinnerLoader';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router-dom';
import './css/index.scss';

const DIACRITICS = [
  'ă','â','î','ș','ț',  
  'Ă','Â','Î','Ș','Ț'
];

class AddTab extends React.Component {

  constructor (props) {
    super(props);
    this.state = {
      title: '',
      artist: '',
      content: '',
      showSuccessMessage: false,
      tabLines: []
    };
  }

  insertAtCaret = (areaId, text) => {
    let txtarea = document.getElementById(areaId);
		var scrollPos = txtarea.scrollTop;
    var strPos = 0;
    var range = false;
		var br = ((txtarea.selectionStart || txtarea.selectionStart === 0) ? 
			"ff" : (document.selection ? "ie" : false ) );
		if (br === "ie") { 
			txtarea.focus();
			range = document.selection.createRange();
			range.moveStart ('character', -txtarea.value.length);
			strPos = range.text.length;
		}
		else if (br === "ff") strPos = txtarea.selectionStart;
	
		var front = (txtarea.value).substring(0,strPos);  
		var back = (txtarea.value).substring(strPos,txtarea.value.length); 
		txtarea.value=front+text+back;
		strPos = strPos + text.length;
		if (br === "ie") { 
			txtarea.focus();
			range = document.selection.createRange();
			range.moveStart ('character', -txtarea.value.length);
			range.moveStart ('character', strPos);
			range.moveEnd ('character', 0);
			range.select();
		}
		else if (br === "ff") {
			txtarea.selectionStart = strPos;
			txtarea.selectionEnd = strPos;
			txtarea.focus();
		}
    txtarea.scrollTop = scrollPos;
    this.setState({content: front+text+back});
	}

  insertDiacritics = (d) => {
    this.insertAtCaret('tabContent', d);
  }

  sendForAproval = () => {
    this.props.setFormSubmitting();
    this.props.tabSubmit({
      title: this.state.title,
      artist: this.state.artist,
      body: this.state.content,
      bodyRendered: this.renderTabFinal(this.state.content)
    });
  }

  renderTab = () => {
    let content = this.state.content;
    let lines = content.split(/\r?\n/);
    // onClick={() => { this.setState({tabLines: tabLines.push(index)})}}
    return lines.map((line, index) => {
      return <div key={'l'+index}><input id={`l_` + index} name={index} onChange={this.handleChangeChk} className="checkboxTabLine" type="checkbox" /><label className="labelTab" htmlFor={`l_` + index}>{this.renderLine(line)} &nbsp;</label></div>;
    });
  }

  handleChangeChk = (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const lineIndex = target.name;
    let tabLines = this.state.tabLines;
    if(value === true)
    {
      tabLines.push(lineIndex);
      this.setState({tabLines});
    }
    else
    {
      let index = tabLines.indexOf(lineIndex)
      if (index !== -1) {
        tabLines.splice(index, 1);
        this.setState({tabLines});
      }
    }
  }

  renderLine = (line) => {
    let segments = line.split(" ");
    return segments.map((segment, index) => {
      return (segment === '' || segment === ' ') ? <span key={'lk'+index}> </span> : <span key={'lk'+index}><span className="w">{segment}</span><span> </span></span>;
    })
  }

  renderTabFinal(){
    let content = this.state.content;
    let lines = content.split(/\r?\n/);
    let str = '';
    let tabLines = this.state.tabLines;
    lines.map((line, index) => {
      let ind = tabLines.indexOf(index.toString())
      if (ind !== -1) {
        // let ind2 = tabLines.indexOf((index-1).toString());
        // if(ind2 !== -1 || lines[index-1].length === 0) // prev line is a chord line or empty
        // {
        //   let output = line;
        //   let lineSegments = line.split(" ");
        //   let cursor = 0;
        //   lineSegments.map((seg, segIndex) => {
        //     if(seg === ''){
        //       cursor++;
        //     } 
        //     else
        //     {
        //       output = [output.slice(0, (cursor)), '((' + seg + '))', output.slice(cursor+seg.length)].join('');
        //       cursor += 4; // for the  (())
        //       cursor += seg.length * 2;
        //     }
        //     return 0;
        //   });
        //   str += output;
        //   str += "\r\n";
        // }
      }
      else
      {
        let ind = tabLines.indexOf((index-1).toString());
        // let ind2 = tabLines.indexOf(index.toString());
      
        if (ind !== -1 ){//&& ind2 === -1){ // previous line was chords line & current line is not chord line
          
          let cursor = 0;
          let prevLine = lines[index-1];
          let prevLineSegments = prevLine.split(" ");
          let output = line;
          let prevSeg = null;
          prevLineSegments.map((seg, segIndex) => {
            if(prevSeg !== '' && prevSeg !== null)
            {
                cursor++;
            }
            if(seg === ''){
              cursor++;
            } 
            else
            {
              if(prevLine.length > output.length)
              {
                output += (new Array(prevLine.length - output.length).join(' '));
              }
              output = [output.slice(0, (cursor)), '((' + seg + '))', output.slice(cursor)].join('');
              cursor += 4; // for the  (())
              cursor += seg.length * 2;
            } 
            prevSeg = seg;
            return 0;
          });
          str += output;
          str += "\r\n";
        }
        else
        {
          str += line + " \r\n";
        }
      }
      return 0;
    });
    return str;
  }

  componentDidUpdate(){
    if(this.state.showSuccessMessage === false && this.props.tabResponse !== null)
    {
      if(this.props.tabResponse.tabSubmission.id > 0)
      {
        this.setState({
          showSuccessMessage: true,
          title: '',
          artist: '',
          content: '',
        }, () => {
          setTimeout(()=>{
            
            this.props.history.push('/tabulaturile-mele');
            this.props.clearTabResponse();
          }, 5000);
        });
      }
    }
    else
    {
      if(this.state.showSuccessMessage === true && this.props.tabResponse === null)
      {
        this.setState({showSuccessMessage: false});
      }
    }
  }

  render () {
    return (
      <div className="addTabContainer">
        <div className="mainHeader"></div>
        <div className="container">
          <div className="article">
          <Link className="regularLink" style={{float: 'right', marginTop: '22px'}} to="/tabulaturile-mele">↑ Tabulaturile mele</Link>
            <h1>Adaugă tabulatură</h1>
              <div className="rowWrapper">
                <div className="pb30 col pr10">
                  {this.props.tabErrors !== null && this.props.tabErrors.title !== undefined ? <div className="error-text">{this.props.tabErrors.title.join(' ')}</div> : null}
                  <input className="addTabInput" onChange={(e) => {this.setState({title: e.target.value})}} value={this.state.title} type="text" placeholder="Titlul Piesei" />
                </div>
                <div className="pb30 col pl10">
                  {this.props.tabErrors !== null && this.props.tabErrors.artist !== undefined ? <div className="error-text">{this.props.tabErrors.artist.join(' ')}</div> : null}
                  <input className="addTabInput" onChange={(e) => {this.setState({artist: e.target.value})}} value={this.state.artist} type="text" placeholder="Nume Artist" />
                </div>
              </div>
              
              <div className="diactritice pb30">
              {DIACRITICS.map((d) => {
              return <button key={d} onClick={() => {this.insertDiacritics(d);}}>{d}</button>;
              })}
              </div>
              <div className="rowWrapper">
                <div className="pb30 col pr10">
                  {this.props.tabErrors !== null && this.props.tabErrors.body !== undefined ? <div className="error-text">{this.props.tabErrors.body.join(' ')}</div> : null}
                  <div style={{padding: '10px 0'}}>Adăugați aici acordurile cu versuri:</div>
                  <textarea id="tabContent" onChange={(e) => {
                    this.setState({content: e.target.value});
                    }} className="addTabContent"  value={this.state.content} rows="10" autoComplete="off"></textarea>
                    {this.props.tabErrors !== null && this.props.tabErrors.body !== undefined ? <div className="error-text">{this.props.tabErrors.body.join(' ')}</div> : null}
                </div>
                <div className="pb30 col pl10">
                  {this.props.tabErrors !== null && this.props.tabErrors.body !== undefined ? <div className="error-text">{this.props.tabErrors.body.join(' ')}</div> : null}
                  <div style={{padding: '10px 0'}}>Previzualizați aici și selectați rândurile cu acorduri:</div>
                  <div className="addTabPreview">
                    {this.renderTab()}
                  </div>
                </div>
                
              </div>

              {/* <div className="pb30 col pr10">
                  <textarea id="tabContent" onChange={(e) => {
                    this.setState({content: e.target.value});
                    }} className="addTabContent"  value={this.renderTabFinal(this.state.content)} rows="10" autoComplete="off"></textarea>
                    {this.props.tabErrors !== null && this.props.tabErrors.body !== undefined ? <div className="error-text">{this.props.tabErrors.body.join(' ')}</div> : null}
              </div> */}

              <div className="pb30">
                  
                <button className="addTabSubmit" onClick={this.sendForAproval}>Trimite Spre Aprobare</button>
              </div>
              {this.state.showSuccessMessage === true ? <div className="mesaj-succes">Tabulatura a fost trimisă cu succes. Îți mulțumim pentru contribuție! Vei fi redirectat în câteva secunde pe pagina cu tabulaturile tale, unde poți urmări progresul celor trimise către apropbare. Dacă vrei să ajungi acolo mai repede poți da click  <Link className="regularLink" to="/tabulaturile-mele">aici</Link>.</div> : null}
          </div>
        </div>
        {this.props.formSubmitting === true ? (<SpinnerLoader />) : null}
      </div>
    );
  }
}

export default withRouter(AddTab);



// WEBPACK FOOTER //
// ./src/components/addTab/addTab.js